export default {
  SET_DASHBOARD_IS_LOADING: 'SET_DASHBOARD_IS_LOADING',
  SET_OUTSTANDING_FORMS: 'SET_OUTSTANDING_FORMS',
  SET_DOR_STATS: 'SET_DOR_STATS',
  SET_WOR_STATS: 'SET_WOR_STATS',
  SET_FTO_STATS_ACTIVE: 'SET_FTO_STATS_ACTIVE',
  SET_OIT_STATS_ACTIVE: 'SET_OIT_STATS_ACTIVE',
  SET_OIT_STATS_REMEDIAL: 'SET_OIT_STATS_REMEDIAL',
  SET_ASSIGNED_OITS: 'SET_ASSIGNED_OITS',
  SET_TRAINING_PROGRAMS_STATS_TOTAL_WEEKS: 'SET_TRAINING_PROGRAMS_STATS_TOTAL_WEEKS',
  SET_RISK_ALERTS_STATS: 'SET_RISK_ALERTS_STATS',
}